import { RootState } from "@/store/store";
import { GetUsersMeProviderConnectionsSnowflakeQueryApiResponse } from "@/services/cloudchipr.api";
import { snowflakeConnectionQuerySelector } from "@/store/provider-connections/selectors/snowflake/snowflakeConnectionQuerySelector";

export const snowflakeConnectionCommandSelector = (
  state: RootState,
):
  | GetUsersMeProviderConnectionsSnowflakeQueryApiResponse["query"]
  | undefined => {
  return snowflakeConnectionQuerySelector(state)?.query;
};
